import { TipoValidacion } from './TipoValidacion';

export class Validacion {
  public id: number;
  public codigo: string;
  public nombre: string;
  public tipo: TipoValidacion;
  public fechaCreacion: string;
  public fechaActualizacion: string;
  public usuarioActualizador: string;
  public habilitado: boolean;
  constructor(
    id: number,
    codigo: string,
    nombre: string,
    tipo: TipoValidacion,
    fechaCreacion: string,
    fechaActualizacion: string,
    usuarioActualizador: string,
    habilitado: boolean
  ) {
    this.id = id;
    this.codigo = codigo;
    this.nombre = nombre;
    this.tipo = tipo;
    this.fechaCreacion = fechaCreacion;
    this.fechaActualizacion = fechaActualizacion;
    this.usuarioActualizador = usuarioActualizador;
    this.habilitado = habilitado;
  }
}
